import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import translate from '../other/translate.json';

export default function CardManager(props) {
  const classes = useStyles();
  const lang = localStorage.getItem('language') || 'Ru'

  return (
    <Card className={classes.root} style={{ backgroundColor: props.bgcolor === 'paper' ? '#FFFFFF' : '#F6F6FB' }}>
      <a href={props.link} className={classes.link} target='_blank' rel="noopener noreferrer">
        <CardContent className={classes.contentCntr}>
          <Grid container direction="column" className={classes.dataCntr}>
            <Grid item container>
              <Typography variant="body2" color="textPrimary" component="p" className={classes.Title4}>
                {translate.Words[`Promo${lang}`]}
              </Typography>
            </Grid>

            <Grid item container
              direction="column"
              justify="flex-start"
              alignItems="flex-start" style={{ marginTop: 14, minHeight: 161 }}
            >
              <Grid item container>
                <Typography variant="body2" color="textPrimary" component="p" className={classes.Title3}>
                  {props.title}
                </Typography>
              </Grid>

              <Grid item container style={{ marginTop: 17 }}>
                <Typography variant="body2" color="textSecondary" component="p" className={classes.Body1}>
                  {props.info}
                </Typography>
              </Grid>
            </Grid>

            <Grid item cotainer style={{ textAlign: 'right', marginTop: 16 }}>
              <Typography variant="body2" color="textPrimary" component="p" className={classes.Body1}>
                {translate.Words[`ValidFrom1${lang}`]}  {props.start} {translate.Words[`ValidFrom2${lang}`]} {props.end}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </a>
    </Card>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 300,
    height: 300,
    maxHeight: 300,
    maxWidth: 648,
    minWidth: 648,
    backgroundColor: '#F6F6FB',
    borderRadius: 16,
    padding: theme.spacing(3),
    boxShadow: 'none',

    [theme.breakpoints.down(696)]: {
      height: 'unset',
      padding: theme.spacing(3),
      maxWidth: 648,
      minWidth: 'unset',
      boxShadow: 'none',
      maxHeight: 'unset',
      minHeight: 'unset',
      borderRadius: 16,
      backgroundColor: '#F6F6FB',
    }
  },

  contentCntr: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0
    },
  },

  dataCntr: {
    // width: 241,
  },

  Title3: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '24px',
    lineHeight: '32px',
    color: '#000000'
  },

  Body1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2'
  },

  Title4: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '28px',
    color: '#8987A2'
  },

  link: {
    textDecoration: 'none'
  }
}));
